import { render, staticRenderFns } from "./SellOrder.vue?vue&type=template&id=a5867752"
import script from "./SellOrder.vue?vue&type=script&lang=js"
export * from "./SellOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports